module.exports = __webpack_public_path__ + "img/database.1f1bfbee.png";